"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FileSubmitIcon = void 0;
var _react = _interopRequireDefault(require("react"));
var _createIconComponent = _interopRequireDefault(require("../createIconComponent"));
var FileSubmit = function FileSubmit(props) {
  return /*#__PURE__*/_react.default.createElement("svg", props, /*#__PURE__*/_react.default.createElement("path", {
    d: "M14 9H4.5a.5.5 0 010-1H14a.5.5 0 010 1zm-3.5 3h-6a.5.5 0 010-1h6a.5.5 0 010 1zm1-6h-7a.5.5 0 010-1h7a.5.5 0 010 1zm-3 9h-4a.5.5 0 010-1h4a.5.5 0 010 1zm0 3h-4a.5.5 0 010-1h4a.5.5 0 010 1z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M10.5 24h-9A1.5 1.5 0 010 22.5v-21A1.5 1.5 0 011.5 0h13.29a1.5 1.5 0 011.06.44l3.71 3.71A1.5 1.5 0 0120 5.21V8.5a.5.5 0 01-1 0V5.21a.51.51 0 00-.15-.36l-3.7-3.7a.49.49 0 00-.36-.15H1.5a.5.5 0 00-.5.5v21a.5.5 0 00.5.5h9a.5.5 0 010 1z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M17.5 24a6.5 6.5 0 116.5-6.5 6.51 6.51 0 01-6.5 6.5zm0-12a5.5 5.5 0 105.5 5.5 5.51 5.51 0 00-5.5-5.5z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M21 17.69a.5.5 0 000-.38.36.36 0 00-.11-.16L18.6 14.9a.49.49 0 00-.7.7l1.39 1.4H14.5a.5.5 0 000 1h4.79l-1.39 1.4a.48.48 0 000 .7.48.48 0 00.7 0l2.25-2.25a.36.36 0 00.15-.16z"
  }));
};
FileSubmit.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
const FileSubmitIcon = exports.FileSubmitIcon = (0, _createIconComponent.default)(FileSubmit, 'FileSubmit');